export const SCHEDULING_CUSTOMER_MESSAGE_TEST_ID = 'scheduling-customer-message';
export const EXTERNAL_ID_INFO_TEST_ID = 'external-id-info';
export const CUSTOMER_TIMEZONE_TEST_ID = 'customer_timezone';

export const TEST_IDS = {
	schedulingCustomerMessage: 'scheduling-customer-message',
	externalIdInfo: 'external-id-info',
	customerTimezone: 'customer_timezone'
};
